import DashboardContent from 'components/lab/atoms/DashboardContent'
import { OutstandingBalancesListing } from 'components/lab/billingPatientStatements/OutstandingBalancesListing'
import routes from 'components/lab/constants/routes'
import React from 'react'

export const PendingStatementsPage: React.FC = () => {
  return (
    <div>
      <DashboardContent
        title={'Outstanding Balances'}
        icon="fa fa-file-invoice"
        content={
          <div>
            <div className="card card-primary mt-1 p-2">
              <OutstandingBalancesListing />
            </div>
          </div>
        }
        breadcrumb={[
          {
            label: 'Billing',
            to: `${routes.index}`,
          },
        ]}
      />
    </div>
  )
}
